import { AppStateType } from '../rootReducer'
export const getUserDocuments = (state: AppStateType) =>
  state.knowledge.documents
export const isKnowledgeCreating = (state: AppStateType) =>
  state.knowledge.saveKnowledge
export const isKnowledgeCreated = (state: AppStateType) =>
  !state.knowledge.saveKnowledge &&
  !state.knowledge.knowledgeError &&
  state.knowledge.knowledgeSaved
export const getlinks = (state: AppStateType) => state.knowledge.links

// All knowledge
export const isAllKnowledgeLoading = (state: AppStateType) =>
  !state.knowledge.allKnowledgeError && state.knowledge.allKnowledgeLoading
export const isAllKnowledgeSuccess = (state: AppStateType) =>
  state.knowledge.allKnowledge
export const isAllKnowledgeError = (state: AppStateType) =>
  state.knowledge.allKnowledgeError && !state.knowledge.allKnowledgeLoading
export const getAllTopicsSelector = (state: AppStateType) =>
  state.knowledge.topics
export const isTopicsLoading = (state: AppStateType) =>
  state.knowledge.topicsLoading
export const iskeyWordsLoading = (state: AppStateType) =>
  state.knowledge.keyWordsLoading
